import React from 'react'

import { useHistory } from 'react-router-dom'

import { Badge, IconButton, Tooltip } from '@material-ui/core'

import { ShoppingCartOutlined } from '@material-ui/icons'

import { routes } from 'routes'
import useSubscribe from 'hooks/useSubscribe'

const CartButton = () => {
  const history = useHistory()
  const subscribe = useSubscribe()

  const handleClick = () => {
    subscribe.setActiveStep(0)
    history.push(routes.subscribe.checkout)
  }

  return (
    <Tooltip title="Carrinho">
      <IconButton onClick={handleClick}>
        <Badge badgeContent={subscribe.sizeCart} color="secondary">
          <ShoppingCartOutlined color="primary" fontSize="large" />
        </Badge>
      </IconButton>
    </Tooltip>
  )
}

export default CartButton
